export default __webpack_public_path__ + "static/jira-screen-new-styles-e2ad57928db06f25ad398766309bea8c9c64edf70a313c7194092fafc843078b.png";